import { reverse } from 'ramda';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { term } from '../../../../packages/JsonQuery';
import { SaveSearchProvider as Provider } from '../../../../packages/SaveSearchModal';
import { selectMapBounds } from '../../../Map/selectors';
import { selectQueryString } from '../../selectors/queryString';
import { selectResultsJsonQuery } from '../../selectors/results';
import { selectUser } from '../../selectors/user';
import { getSaveSearchMicrofrontend } from '../../services/getSaveSearchMicrofrontend';
import { useApplicationContext } from '../ApplicationContext';

enum ESource {
  Card = 'card',
  Listing = 'listing',
  Map = 'map',
}

export const SaveSearchModalProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getSaveSearchMicrofrontend(context), [context]);

  const [title, setTitle] = React.useState<string | null>(null);
  const user = useSelector(selectUser);
  const email = React.useMemo(() => (user?.isAuthenticated ? user.email : null), [user]);
  const isAuthenticated = !!user?.isAuthenticated;

  const queryString = useSelector(selectQueryString);
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const mapBounds = useSelector(selectMapBounds);
  const jsonQueryBounds = React.useMemo(
    () => term(mapBounds.bounds?.map(bounds => reverse(bounds)) as [YMaps.TCoord, YMaps.TCoord]),
    [mapBounds],
  );

  React.useEffect(() => {
    setTitle(document.title);
  }, []);

  const params = {
    email,
    title,
    isAuthenticated,
    source: ESource.Map,
    jsonQuery: {
      ...jsonQuery,
      bbox: jsonQueryBounds,
    },
    analyticsParams: {
      pageType: 'Filter',
      listingType: ESource.Map,
      isFromBanner: false,
      queryString,
    },
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
